import { ExternalInvitation } from '@/domain/external-invitation/entities/external-invitation.entity';
import { selectSurveyResultByInvitationId } from '@/domain/external-invitation-survey/external-invitation-survey.selectors';
import { Co2Section } from '@/domain/impact-co2/entities/question.entity';
import { FSModal } from '@/ui/components/modal/FSModal';
import { FSModalTitle } from '@/ui/components/modal/FSModalTitle';
import { useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

import { AccommodationData } from '../../app/components/quiz-panel/co2/components/public-answers/AccommodationData';
import { TransportData } from '../../app/components/quiz-panel/co2/components/public-answers/TransportData';
import { QuizFormSeparator } from '../../app/components/quiz-panel/co2/components/QuizFormSeparator';

export function ModalSurveyAnswers({
  open,
  invitation,
  onClose,
}: {
  open: boolean;
  invitation: ExternalInvitation;
  onClose: () => void;
}) {
  const statsPublic = useAppSelector(
    selectSurveyResultByInvitationId(invitation.id),
  );

  return (
    <FSModal open={open} onClose={onClose} showCloseButton maxWidth={800}>
      <FSModalTitle title={invitation.title} />
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.MOBILITY}`)}
      />
      <TransportData statsPublic={statsPublic} />
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.ACCOMMODATION}`)}
      />
      <AccommodationData statsPublic={statsPublic} />
    </FSModal>
  );
}
